export default __webpack_public_path__ + "static/media/2373.5c6f0c1c.png";